import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { PAY_URL } from "../../../BaseURL";


export const deleteBank = createAsyncThunk(
    '/delete/deleteBank',
    async (id) => {

        // console.log(id, "ID");

        try {
            const myurl = `${PAY_URL}/admin/delete-bank`;

            const response = await axios({
                method: 'delete',
                url: myurl,
                data: id,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_ADMIN_TOKEN')
                },
            });

            const deleteBank = response.data;
            // console.log(deleteBank, '@@@')

            if (deleteBank.success === true) {
                toast.success(deleteBank?.message);
                return deleteBank;
            } else {
                // console.log(deleteBank.message, "&&&&")
                throw new Error(deleteBank.message);
            }
        } catch (error) {
            console.log(error, "!!!!")
            toast.error(error?.response?.data?.message);
        }
    }
);


const deleteBankSlice = createSlice({
    name: "deleteBank",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(deleteBank.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteBank.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(deleteBank.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default deleteBankSlice.reducer;